export const getBrandContext = (brandName: string): string => `Brand - ${brandName}`;
